<div class="flex flex-col flex-auto min-w-0">
    <!-- Main -->
    <div class="flex-auto p-6 sm:p-10">
        
        <div>


            <div class="flex items-center justify-between w-full ">
                <h2 class="text-3xl font-semibold tracking-tight leading-8"
                    i18n="Inventories Overview Component header">
                    {{ "PURCHASE_ORDER_MODULE.PO_COMPONENT.HEADER" | translate }}
                </h2>
            </div>

            <div>
                <h2 class="page-sub-header"
                    i18n="Inventories Overview Component sub header">
                    {{ "PURCHASE_ORDER_MODULE.PO_COMPONENT.SUB_HEADER" | translate }}
                </h2>
            </div>


            <div class="content">
                <!-- <div
                    *ngIf="showDeletSuccess"
                    style="
                        background-color: greenyellow;
                        z-index: 1000;
                        position: fixed;
                        padding: 10px;
                        height: 40px;
                        display: block;
                        right: 30px;
                        top: 70px;
                    "
                    i18n="PO delivery updated successfully - message"
                >
                    {{
                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.SHOW_MESSAGES.PO_DELETE"
                            | translate
                    }}
                </div> -->
                <div style="text-align: right">

                    <button

                        class="back-button"
                        *ngIf="showAddButton"
                        routerLink="./add"
                    >
                        {{
                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.CREATE_PO_BUTTON_LABEL.TITLE"
                                | translate
                        }}
                    </button>
                </div>
                <mat-tab-group
                    *ngIf="!addPurchaseOrder"
                    (selectedTabChange)="onTabChanged($event)"
                >
                    <!-- New  Open-->
                    <!-- <mat-tab label="{{ 'PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.LABEL' | translate }}">
      <ng-template matTabContent>
        <br>
        <br>

        <table *ngIf="totalCount>0" class="table table-striped tablefixed">
          <thead>
            <tr>
              <th>{{ 'PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.PO_NUMBER' | translate }}</th>
              <th>{{ 'PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.MANUFACTURER' | translate }}</th>
              <th>{{ 'PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.SUPPLIER' | translate }}</th>
              <th>{{ 'PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.DATE' | translate }}</th>
              <th>{{ 'PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.ADDED_TO_INVENTORY' | translate }}</th>
              <th>{{ 'PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.EDIT' | translate }}</th>


            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let po of poList">
              <td>{{po.poNumber}}</td>
              <td>{{po.manufacturerName}}</td>
              <td>{{po.supplierName}}</td>
              <td>{{po.poDate | date:'mediumDate'}}</td>
              <td>
                <span *ngIf="po.pendingInventory >0">No</span>
                <span *ngIf="po.pendingInventory ==-1">No</span>
                <span *ngIf="po.pendingInventory == 0 || po.pendingInventory ==null">Yes</span>

              </td>
              <td>
                <mat-icon matTooltip="Edit Purchase Order" (click)="onEditPo(po)" style="color: darkturquoise;">
                  edit</mat-icon>
              </td>


            </tr>
          </tbody>
        </table>
        <div *ngIf="totalCount>0">
          <mat-paginator [length]=totalCount [pageSize]=pageSize (page)="paginatorEvent($event)"
            [pageSizeOptions]="[5, 10, 25, 100]">
          </mat-paginator>
        </div>
        <div *ngIf="totalCount==0">
          <span> {{'PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.EMPTY_LIST' | translate }}
          </span>
        </div>
      </ng-template>
    </mat-tab> -->
                    <!-- Deliveries -->
                    <mat-tab
                        label="{{
                            'PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DELIVERIES.LABEL'
                                | translate
                        }}"
                    >
                        <ng-template matTabContent>
                            <br />

                            <div
                                *ngIf="totalCount > 0"
                                id="search-purchase-order"
                            >
                                <input
                                    class="form-control"
                                    (keyup)="
                                        searchPOFromList($event.target.value)
                                    "
                                    placeholder="{{
                                        'PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.SEARCH_PO'
                                            | translate
                                    }}"
                                />
                            </div>
                            <br />
                            <table
                                *ngIf="totalCount > 0"
                                class="table table-striped tablefixed"
                            >
                                <thead>
                                    <tr>
                                        <th>
                                            {{
                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.PO_NUMBER"
                                                    | translate
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.MANUFACTURER"
                                                    | translate
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.SUPPLIER"
                                                    | translate
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.DATE"
                                                    | translate
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.ADDED_TO_INVENTORY"
                                                    | translate
                                            }}
                                        </th>
                                        <th>
                                            {{
                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.EDIT"
                                                    | translate
                                            }}
                                        </th>

                                        <th>
                                            {{
                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.VIEW"
                                                    | translate
                                            }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let po of openDeliveryList">
                                        <td>{{ po.poNumber }}</td>
                                        <td>{{ po.manufacturerName }}</td>
                                        <td>{{ po.supplierName }}</td>
                                        <td>
                                            {{ po.poDate | date: "mediumDate" }}
                                        </td>
                                        <td>
                                            <span
                                                *ngIf="po.pendingInventory > 0"
                                                >No</span
                                            >
                                            <span
                                                *ngIf="
                                                    po.pendingInventory == -1
                                                "
                                                >No</span
                                            >
                                            <span
                                                *ngIf="
                                                    po.pendingInventory == 0 ||
                                                    po.pendingInventory == null
                                                "
                                                >Yes</span
                                            >
                                        </td>
                                        <td>
                                            <mat-icon
                                                matTooltip="Edit Purchase Order"
                                                (click)="onEditPo(po)"
                                                style="color: darkturquoise"
                                            >
                                                edit</mat-icon
                                            >
                                        </td>
                                        <td>
                                            <a (click)="ViewDetailPo(po.id)">{{
                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.TABLE_HEADERS.VIEW"
                                                    | translate
                                            }}</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div *ngIf="totalCount > 0">
                                <mat-paginator
                                    [length]="totalCount"
                                    [pageSize]="pageSize"
                                    (page)="paginatorEvent($event)"
                                    [pageSizeOptions]="[5, 10, 25, 100]"
                                >
                                </mat-paginator>
                            </div>
                            <div *ngIf="totalCount == 0">
                                <span>{{
                                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DELIVERIES.EMPTY_LIST"
                                        | translate
                                }}</span>
                            </div>
                        </ng-template>
                    </mat-tab>
                    <!-- History -->
                    <mat-tab
                        label="{{
                            'PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_HISTORY.LABEL'
                                | translate
                        }}"
                    >
                        <ng-template matTabContent>
                            <br />

                            <div
                                *ngIf="totalCount > 0"
                                id="search-purchase-order"
                            >
                                <input
                                    class="form-control"
                                    (keyup)="
                                        searchPOFromCloseOrderList(
                                            $event.target.value
                                        )
                                    "
                                    placeholder="{{'PURCHASE_ORDER_MODULE.PO_COMPONENT.OPEN_PO.SEARCH_PO'|translate}}"
                                />
                            </div>
                            <br />
                            <br />

                            <mat-accordion *ngIf="totalCount > 0">
                                <mat-expansion-panel
                                    *ngFor="let po of closeOrders"
                                >
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <strong> {{ po.poNumber }}</strong>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <div>
                                        <table class="poDetails">
                                            <tr>
                                                <th>
                                                    {{
                                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.SUPPLIER"
                                                            | translate
                                                    }}:
                                                </th>
                                                <td>-</td>
                                                <td>
                                                    &nbsp;{{ po.supplierName }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    {{
                                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.MANUFACTURER"
                                                            | translate
                                                    }}:
                                                </th>
                                                <td>-</td>
                                                <td>
                                                    &nbsp;{{
                                                        po.manufacturerName
                                                    }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    {{
                                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.PO_DATE"
                                                            | translate
                                                    }}:
                                                </th>
                                                <td>-</td>
                                                <td>
                                                    &nbsp;{{
                                                        po.poDate
                                                            | date: "mediumDate"
                                                    }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    {{
                                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.APPROVED_BY"
                                                            | translate
                                                    }}:
                                                </th>
                                                <td>-</td>
                                                <td>
                                                    &nbsp;{{ po.approvedBy }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    {{
                                                        "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.REFERENCE_NUMBER"
                                                            | translate
                                                    }}:
                                                </th>
                                                <td>-</td>
                                                <td>
                                                    &nbsp;{{
                                                        po.referenceNumber
                                                    }}
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                    <br />
                                    <div>
                                        <table
                                            class="table table-striped tablefixed"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>
                                                        {{
                                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_HISTORY.TABLE_HEADERS.NAME"
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_HISTORY.TABLE_HEADERS.REQUESTED_QUANTITY"
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_HISTORY.TABLE_HEADERS.RECEIVED_QUANTITY"
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_HISTORY.TABLE_HEADERS.UNIT"
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_HISTORY.TABLE_HEADERS.STATUS"
                                                                | translate
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_HISTORY.TABLE_HEADERS.PARTIAL_DELIVERIES"
                                                                | translate
                                                        }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="
                                                        let item of po.poItems
                                                    "
                                                >
                                                    <td>
                                                        {{ item.formulaName }}
                                                    </td>
                                                    <td>{{ item.quantity }}</td>

                                                    <td>
                                                        {{
                                                            item.receivedQuantity
                                                        }}
                                                    </td>
                                                    <td>
                                                        <span
                                                            *ngIf="
                                                                item.unit ==
                                                                pOUnitEnum.KG
                                                            "
                                                        >
                                                            {{
                                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.KG"
                                                                    | translate
                                                            }}
                                                        </span>
                                                        <span
                                                            *ngIf="
                                                                item.unit ==
                                                                pOUnitEnum.TONNE
                                                            "
                                                        >
                                                            {{
                                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_UNIT.TONNE"
                                                                    | translate
                                                            }}
                                                        </span>
                                                    </td>

                                                    <td>
                                                        <span
                                                            *ngIf="
                                                                item.status ==
                                                                OrderStatusEnum.COMPLETED
                                                            "
                                                            >{{
                                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.ITEM_STATUS.COMPLETED"
                                                                    | translate
                                                            }}
                                                        </span>
                                                        <span
                                                            *ngIf="
                                                                item.status ==
                                                                OrderStatusEnum.PARTIALLY_COMPLETED
                                                            "
                                                            >{{
                                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_DETAILS.ITEM_STATUS.PARTIALLY_COMPLETED"
                                                                    | translate
                                                            }}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <a
                                                            *ngIf="
                                                                item.poItemDeliveryDtos !=
                                                                null
                                                            "
                                                            (click)="
                                                                showPartialDeliveries(
                                                                    item
                                                                )
                                                            "
                                                            >{{
                                                                "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_HISTORY.BUTTONS.SHOW_DELIVERIES"
                                                                    | translate
                                                            }}</a
                                                        >
                                                        <span
                                                            *ngIf="
                                                                item.poItemDeliveryDtos ==
                                                                null
                                                            "
                                                            >-</span
                                                        >
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                            <div *ngIf="totalCount > 0">
                                <mat-paginator
                                    [length]="totalCount"
                                    [pageSize]="pageSize"
                                    (page)="closeOrderPaginatorEvent($event)"
                                    [pageSizeOptions]="[5, 10, 25, 100]"
                                >
                                </mat-paginator>
                            </div>
                            <div *ngIf="totalCount == 0">
                                <span>{{
                                    "PURCHASE_ORDER_MODULE.PO_COMPONENT.PO_HISTORY.EMPTY_LIST"
                                        | translate
                                }}</span>
                            </div>
                        </ng-template>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>
